<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Role')" style="position:relative">
          <b-form @submit.prevent="onSubmitDetails" autocomplete="off" ref="det">
            <FloatingLabel v-model="details.name" label="Name" autocomplete="false" size="sm"/>

            <FloatingLabel
              v-model="details.description"
              label="Description"
              autocomplete="false"
              type="textarea"
              size="sm"
            />

            <div class="mb-2 position-relative">
              <div
                class="multiselect-lbl"
                v-if="details.permissions && details.permissions.length"
              >{{$t('Roles')}}</div>
              <multiselect
                v-model="details.permissions"
                :options="permissionsList"
                :multiple="true"
                :close-on-select="false"
                :hide-selected="true"
                placeholder="Select permission"
                track-by="name"
                label="name"
                :translate="false"
              ></multiselect>
            </div>

            <div style="text-align:right">
              <b-dropdown variant="success" right split :text="$t('Save')" @click="onSubmitDetails">
                <b-dropdown-item @click="saveAsNew">{{$t('Save As New')}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "@/components/multiselect-filters";
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";

export default {
  name: "role",
  props: ["selectedeid"],
  components: {
    Multiselect,
    FloatingLabel
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    this.$store.dispatch("permissions/fetch").finally(() => {
      if (this.eid != "0" && this.eid != "") {
        this.loadData();
      } else {
        this.newRole = true;
      }
    });
  },
  data: function() {
    return {
      eid: "",
      details: {
        name: "",
        description: "",
        permissions: []
      },
      newRole: false,

      temp: {}
    };
  },
  computed: {
    permissionsList() {
      return this.$store.getters["permissions/permissions"];
    }
  },
  methods: {
    loadData() {
      if (this.eid == "") {
        // new role; nothing to load
        return;
      }
      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      this.$store
        .dispatch("role/read", this.eid)
        .then(resp => {
          this.temp = resp.data;
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    saveAsNew() {
      this.eid = "";
      this.newRole = true;
      this.onSubmitDetails();
    },
    onSubmitDetails() {
      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "role/update";
      if (this.newRole) {
        apiAction = "role/create";
      } else {
        detailsData.eid = this.eid;
      }

      let tmp = [];
      for (let i = 0; i < detailsData.permissions.length; i++) {
        tmp.push(detailsData.permissions[i].name);
      }
      if (tmp.length == 0) tmp = null;
      detailsData.permissions = tmp;

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Role updated";
          if (this.newRole && resp.data.id) {
            this.updateRoleId(resp.data.id);
            msg = "Role created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";
      this.details.name = r.name;
      this.details.description = r.description;
      this.details.permissions = r.permissions;

      let tmp = [];
      if (this.details.permissions.length > 0) {
        this.permissionsList.forEach(element => {
          for (let i = 0; i < this.details.permissions.length; i++) {
            if (element.name == this.details.permissions[i]) {
              tmp.push(element);
            }
          }
        });
      }
      this.details.permissions = tmp;
    },
    updateRoleId(id) {
      this.eid = id;
      this.newRole = false;
      this.$router.replace({ name: "Role", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
